import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {DataChangesObserver, TitleService} from '@common-lib';

import {CategoriesService, ConfigurationService, ProductsService} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';

@Component({
    selector: 'app-configuration-views',
    templateUrl: './configuration-views.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss','../configuration-views/configuration-views.component.scss'],
})

export class ConfigurationViewsComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'view';

    products = [];
    categories = [];

    viewById = [];
    productsById = [];
    categoriesById = [];

    constructor(
        protected title: TitleService,
        protected route: ActivatedRoute,
        protected toasterService: ToasterService,
        protected dataChanges: DataChangesObserver,
        protected translateService: TranslateService,
        protected configurationService: ConfigurationService,
        private productsService: ProductsService,
        private categoriesService: CategoriesService
    ) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.productsService.getList(this.selectedLocale).subscribe(({products}) => {
            products.forEach(product => {
                const {id, title} = product;
                this.productsById[id] = title;
            });
            this.products = products;
        });

        this.categoriesService.getList(this.selectedLocale).subscribe(({categories}) => {
            categories.forEach(category => {
                const {id, title, productId} = category;
                this.categoriesById[id] = title;
            });

            this.categories = categories;
        });

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        const resource = 'views';
        return new Promise((resolve, reject) => {
            this.configurationService.getList(resource, this.selectedLocale).subscribe(({result}) => {
                result.views.forEach(view => {
                    const {name, id} = view;
                    this.viewById[id] = {name};
                });
                this.state.items = this.createChangesObservation(result.views);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/configuration-views/configuration-views.component.ts